// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "GuestLazyComponent" + "." + "b22c5b6c7de7f5a8bc6f" + ".js";
};